import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
const ScrollToTop = ({ children }) => {
    const location = useLocation();
    const { pathname } = location;
    const prevPathname = useRef(null);
    useEffect(() => {
        if (prevPathname.current && prevPathname.current !== pathname) {
            window.scrollTo(0, 0);
        }
        prevPathname.current = pathname;
    }, [pathname]);
    return _jsx(_Fragment, { children: children });
};
export default ScrollToTop;
